const setEvent = (eventCategory, eventInfo, payload) => {
    pushEventInfo(Object.assign({ category: {
            primaryCategory: eventCategory,
        }, eventInfo }, payload));
};
export const setPageInfo = (type, displayType, pageSection, message, code) => {
    pushPageErrorInfo({
        type,
        displayType,
        pageSection,
        message,
        code,
    });
};
export const pushPageErrorInfo = (pageError) => {
    if (pageError && window.digitalData) {
        window.digitalData.page.error = window.digitalData.page.error || [];
        window.digitalData.page.error.push(pageError);
        setAnalytics(window.digitalData);
    }
};
const setErrorEvent = (pageSection, code, message, displayType) => {
    setEvent('error', {
        eventName: 'post page error',
        error: [
            {
                type: 'error',
                displayType,
                pageSection,
                code,
                message,
            },
        ],
    });
};
export const pushErrorEvent = (pageSection, displayType = 'inline', errCode, errMessage) => {
    setErrorEvent(pageSection, errCode, errMessage, displayType);
};
export const setStashEvent = (eventCategory, eventInfo, eventMode, payload) => {
    pushEventInfo(Object.assign({ category: {
            primaryCategory: eventCategory,
        }, eventInfo,
        eventMode }, payload));
};
export const setOverlayEvent = (eventName, payload) => {
    setEvent('overlay', {
        eventName,
    }, payload);
};
/**
 * Function for updating page data in the global variable _T
 * @param digitalData - the digital data object we want to push to page data array
 * @returns undefined
 */
export const setAnalytics = (digitalData) => {
    const _ddo = digitalData.init();
    window._T = window._T || {};
    if (typeof window._T.pageData === 'undefined') {
        window._T.pageData = [];
    }
    window._T.pageData.push(_ddo);
};
/**
 * Function for updating an event array in the global variable digitalData
 * @param analyticsEvent - an event object we want to push to event array
 * @returns undefined
 */
export const pushEventInfo = (analyticsEvent) => {
    if (analyticsEvent && window.digitalData) {
        try {
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push(analyticsEvent);
            setAnalytics(window.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in pushing the event info!!!');
        }
    }
};
/**
 * Function for setting page details in the global variable digitalData
 * @param page - an page details object we want to set in the digitalData
 * @returns undefined
 */
export function setPageDetails(page) {
    if (window.digitalData) {
        try {
            window.digitalData.page = page;
            setAnalytics(window.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the page object and initializing it!!!');
        }
    }
}
export const track = (name, payload) => {
    if (typeof window !== 'undefined') {
        window.LIFE_CYCLE_EVENT_BUS.trigger(name, payload);
    }
};
